module.exports = __webpack_public_path__ + "static/media/logos.25f77212.png";